import { Nurse } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import { getRatingColor, getRatingText } from '../helper-utils/helper';
import AdmissionUtilization from '../../../public/Images/AccessDashboard/AdmissionUtilization.png';
import ProcedureUtilization from '../../../public/Images/AccessDashboard/ProcedureUtilization.png';
import DiseaseManagement from '../../../public/Images/AccessDashboard/DiseaseManagement.png';
import CareQualityMeasures from '../../../public/Images/AccessDashboard/CareQualityMeasures.png';
import ChronicPrevalenceAnalysis from '../../../public/Images/AccessDashboard/ChronicPrevalenceAnalysis.png';
import ClaimsManagement from '../../../public/Images/AccessDashboard/ClaimsManagement.png';
// import DeductibleCorridors from '../../../public/Images/AccessDashboard/DeductibleCorridors.png';
import DiseaseAnalysisPrevalence from '../../../public/Images/AccessDashboard/DiseaseAnalysisPrevalence.png';
// import DiseasePrognosis from '../../../public/Images/AccessDashboard/DiseasePrognosis.png';
import DrugUtilization from '../../../public/Images/AccessDashboard/DrugUtilization.png';
import DrugUtilizationSummary from '../../../public/Images/AccessDashboard/DrugUtilizationSummary.png';
import EnrollmentMetrics from '../../../public/Images/AccessDashboard/EnrollmentMetrics.png';
import EpisodesOfCare from '../../../public/Images/AccessDashboard/EpisodesOfCare.png';
// import HighCostClaimants from '../../../public/Images/AccessDashboard/HighCostClaimants.png';
import MedicalClaimUtilization from '../../../public/Images/AccessDashboard/MedicalClaimUtilization.png';
import MedPharmaDrugUtilization from '../../../public/Images/AccessDashboard/MedPharmaDrugUtilization.png';
import NetworkLeakage from '../../../public/Images/AccessDashboard/NetworkLeakage.png';
import OtherPrescriptionDrugUtilization from '../../../public/Images/AccessDashboard/OtherPrescriptionDrugUtilization.png';
import PendingClaims from '../../../public/Images/AccessDashboard/PendingClaims.png';
import PlanPerformance from '../../../public/Images/AccessDashboard/PlanPerformance.png';
import PlanUtilization from '../../../public/Images/AccessDashboard/PlanUtilization.png';
import ProviderUtilization from '../../../public/Images/AccessDashboard/ProviderUtilization.png';
import RejectedClaims from '../../../public/Images/AccessDashboard/RejectedClaims.png';
import ReportPlan from '../../../public/Images/AccessDashboard/ReportPlan.png';
import SpecialityDrugUtilization from '../../../public/Images/AccessDashboard/SpecialityDrugUtilization.png';
import StopLossTriggers from '../../../public/Images/AccessDashboard/StopLossTriggers.png';
import StopLossUtilization from '../../../public/Images/AccessDashboard/StopLossUtilization.png';
// import WasteCalculator from '../../../public/Images/AccessDashboard/WasteCalculator.png';
import CostManagement from '../../../public/Images/AccessDashboard/CostManagement.png';
import ClaimsMetrics from '../../../public/Images/AccessDashboard/ClaimsMetrics.png';
import StopLossAggregateReport from '../../../public/Images/AccessDashboard/StopLossAggregateReport.png';
import RiskProfile from '../../../public/Images/AccessDashboard/RiskProfile.png';
import ChronicConditions from '../../../public/Images/AccessDashboard/ChronicConditions.png';
import TriggerConditions from '../../../public/Images/AccessDashboard/TriggerConditions.png';
import HighCostUtilization from '../../../public/Images/AccessDashboard/HighCostUtilization.png';
import MultipleDrugs from '../../../public/Images/AccessDashboard/MultipleDrugs.png';
import CostPercentile from '../../../public/Images/AccessDashboard/CostPercentile.png';
import FinancialForensics from '../../../public/Images/AccessDashboard/FinancialForensics.png';
import BuildScenarios from '../../../public/Images/AccessDashboard/BuildScenarios.png';
import Reconciliation from '../../../public/Images/AccessDashboard/Reconciliation.png';
import DeepDive from '../../../public/Images/AccessDashboard/DeepDive.png';
import TrendAnalysis from '../../../public/Images/AccessDashboard/TrendAnalysis.png';

const CareNavigatorConstants = {
  NO_DATA: {
    TITLE: 'Welcome to our care navigator solution',
    SUB_TITLE:
      'Add a new group and start your onboarding to begin your care navigator journey',
  },
  DASHBOARD: {
    ADD_BUTTON: 'Add new group',
    TITLE: 'Individual groups',
    SUB_TITLE:
      'Click on the individual group to enter care navigation platform.',
    SHOW_ALL: 'Show All Groups',
    ADD_CARE_NAV: '+ Add New',
    SEARCH: 'Search',
  },
  CARE_NAVIGATOR_PAGE: {
    title: 'Care Navigator',
    subTitle: 'Showing Patient Details having high risk driving factor',
    tabList: [
      'Cases',
      'Members',
      // 'Overview',
      'Care Navigators',
      'Ratings & Review',
      // 'Risk Management'
    ],
    topCards: {
      engagements: 'Engagements',
      careNavigators: 'Care Navigators',
      casesOpen: 'Cases Opened',
      casesClosed: 'Cases Closed',
    },
    MEMBERS_DATA: {
      SEARCH: 'Search by Name or Member ID',
      TITLE: {
        unassigned: 'Unassigned Cases',
        activeCases: 'Active Case List',
        closedCases: 'Cases Closed',
        members: 'Members List',
        unassignedDelete: 'Delete Unassigned Case',
        activeDelete: 'Delete Active Case',
        closedDelete: 'Delete Closed Case',
      },
      SUB_TITLE: {
        unassigned: 'Member Of Interest - Unassigned',
        activeCases: 'Showing members having high risk driving factor',
        subTitle: 'Showing patient details',
        closedCases: 'Showing list of patients/members',
        members: 'Showing Members List',
        activeSubTitle: 'Related interactions will also be deleted.',
        closedSubTitle:
          'Related interactions & Case Survey will also be deleted.',
      },
      breadCrumb: {
        text: 'text',
        careNavigation: 'Care Navigation',
      },
    },
    CARE_NAVIGATORS_DATA: {
      title: 'Care Navigators',
      subTitle: 'Showing list of care navigators',
    },
    RATING_REVIEW_DATA: {
      title: 'Ratings & Reviews',
      subTitle: 'Showing Patients rating & review on the care navigator',
      avgRating: 4,
      ratingData: {
        1: 10,
        2: 3,
        3: 29,
        4: 12,
        5: 10,
      },
      data: [
        {
          imageUrl:
            'https://i.scdn.co/image/ab6761610000101f5ba2d75eb08a2d672f9b69b7',
          name: 'Amit Shinde',
          careNavName: 'Harshal Walunj',
          careNavRoleIcon: <Nurse />,
          rating: 1,
          starColor: getRatingColor(1),
          ratingText: getRatingText(1),
          review:
            'Lorem ipsum dolor sit amet consectetur. Semper nisl cursus nunc elit. Pulvinar justo consectetur volutpat ornare sodales ornare mattis sagittis. Adipiscing ullamcorper habitant amet vel sit lacus magna gravida donec. Lorem volutpat velit semper dictum vitae aenean pharetra ',
        },
        {
          imageUrl: '',
          name: 'Amit Shinde',
          careNavName: 'Harshal Walunj',
          careNavRoleIcon: <Nurse />,
          rating: 3,
          starColor: getRatingColor(3),
          ratingText: getRatingText(1),
          review:
            'Lorem ipsum dolor sit amet consectetur. Semper nisl cursus nunc elit. Pulvinar justo consectetur volutpat ornare sodales ornare mattis sagittis. Adipiscing ullamcorper habitant amet vel sit lacus magna gravida donec. Lorem volutpat velit semper dictum vitae aenean pharetra ',
        },
      ],
    },
    DASHBOARD_CARDS: [
      {
        category: 'Disease Management',
        subTitle:
          'Focuses on insights into the prevalence, progression, and management of diseases within a population, aiming to identify, predict, and evaluate care for chronic conditions and disease risks.',
        image: DiseaseManagement,
        subGroups: [
          {
            category: 'Disease and Condition Spend',
            subTitle:
              'Cost and utilization patterns across diagnoses, conditions, and encounters—highlighting major cost drivers and opportunities for targeted health interventions—using ICD classification from the National Center for Health Statistics (NCHS).',
            image: DiseaseAnalysisPrevalence,
            path: '/disease-prelavence',
          },
          {
            category: 'Chronic Prevalence Analysis',
            subTitle:
              'Presents a comprehensive overview of chronic disease prevalence, featuring prevalence rates, cost analysis, and exploring potential interrelationships between conditions.',
            image: ChronicPrevalenceAnalysis,
            path: '/chronic-prelavence',
          },
          // {
          //   category: 'Disease Prognosis',
          //   subTitle:
          //     'Predicts potential disease progression within the next 12-24 months, focusing on members at risk and those already diagnosed to aid in preventative strategies.',
          //   image: DiseasePrognosis,
          //   path: '/rising-risk',
          // },
          {
            category: 'Care Gaps',
            subTitle:
              'Evaluates healthcare quality by identifying gaps in recommended preventive care and comparing performance against national HEDIS measures.',
            image: CareQualityMeasures,
            path: '/care-quality',
          },
        ],
      },
      {
        category: 'Cost Management',
        subTitle:
          'Analyzes and optimizes healthcare costs associated with medical episodes, identifies wasteful spending, and spotlights high-cost claimants to enhance financial efficiency.',
        image: CostManagement,
        subGroups: [
          {
            category: 'Episodes of Care',
            subTitle:
              'Analyzes costs associated with specific healthcare episodes, including pre- and post-surgery care, to assess cost variances and quality of care.',
            image: EpisodesOfCare,
            path: '/episodes-of-care',
          },
          // {
          //   category: 'Waste Calculator',
          //   subTitle:
          //     'Quantifies waste in healthcare, targeting avoidable admissions, imaging overuse, and unnecessary drug and procedure utilization.',
          //   image: WasteCalculator,
          //   path: '/waste-calculator',
          // },
          // {
          //   category: 'High Cost Claimants',
          //   subTitle:
          //     'Identifies members with significant medical or pharmacy claims, showcasing their disproportionate impact on overall plan spending.',
          //   image: HighCostClaimants,
          //   path: '/high-cost-claims',
          // },
          {
            category: 'High Cost Claimants',
            subTitle:
              'When curbing health care costs, the conversation invariably turns to the sickest 10% of the population, who consume 70% of health care spending.',
            image: TriggerConditions,
            path: '/high-cost-claims',
          },
          {
            group: 'Fiscal Controls',
            subTitle:
              'A single view to review fixed and variable costs, experiment with key variables, and uncover savings.',
            image: FinancialForensics,
            path: '/financial-forensics',
          },
          {
            group: 'Scenario Library',
            subTitle:
              'Forecast, Compare & Optimize Financial Scenarios Across Plan Years',
            image: BuildScenarios,
            path: '/scenario-library',
          },
          {
            group: 'Reconciliation Library',
            subTitle:
              'Streamline and Optimize Financial Reconciliation Processes',
            image: Reconciliation,
            path: '/reconciliation-library',
          },
        ],
      },
      {
        category: 'Stop Loss Management',
        subTitle:
          'Manages and mitigates financial risks associated with stop loss insurance, focusing on identifying conditions that trigger stop loss claims, analyzing deductible levels, and evaluating financial impact.',
        image: StopLossUtilization,
        subGroups: [
          {
            category: 'Stop Loss Aggregate Report',
            subTitle:
              'Detailed Monthly Breakdown of Paid Claims, Coverage Limits, and Enrollee Statistics',
            image: StopLossAggregateReport,
            path: '/stoploss-report',
          },
          {
            category: '50-50 Report Plan',
            subTitle:
              'Reveals the impact of common stop loss deductible levels on member claims, showing the percentage of members exceeding these thresholds.',
            image: ReportPlan,
            path: '/report-plan',
          },
          {
            category: 'Stop Loss Triggers',
            subTitle:
              'Identifies conditions prone to trigger stoploss claims, based on SIIA criteria, including member counts and cost contributions.',
            image: StopLossTriggers,
            path: '/stoploss-triggers',
          },
          // {
          //   category: 'Deductible Corridors',
          //   subTitle:
          //     'Analyzes the effect of adjusting deductible corridors for stop loss and captive plans, including historical data on member claims surpassing these limits.',
          //   image: DeductibleCorridors,
          //   path: '/specific-deductible-corridors',
          // },
        ],
      },
      {
        category: 'Plan Analysis',
        subTitle:
          "Provides a comprehensive analysis of the healthcare plan's performance, including claims cost distribution, enrollment metrics, and the effect of network usage on expenses.",
        image: PlanUtilization,
        subGroups: [
          {
            category: 'Plan Performance',
            subTitle:
              'Offers an in-depth analysis of claims costs over time, including insights into network usage and the distribution of medical/Rx costs.',
            image: PlanPerformance,
            path: '/plan-performance',
          },
          {
            category: 'Claims Metrics',
            subTitle:
              'Details a breakdown of all plan charges by member and network, facilitating financial oversight.',
            image: ClaimsMetrics,
            path: '/claims-metrics',
          },
          {
            category: 'Enrollment Metrics',
            subTitle:
              'Details member demographics and their selected plan types, aiding in plan design and management.',
            image: EnrollmentMetrics,
            path: '/enrollment-metrics',
          },
          {
            category: 'Network Usage',
            subTitle:
              'Compares the distribution and cost implications of in-network versus out-of-network provider claims.',
            image: NetworkLeakage,
            path: '/network-leakage',
          },
        ],
      },
      {
        category: 'Claims Management',
        subTitle:
          'Dedicated to the operational aspect of managing healthcare claims, aiming to improve the efficiency of claims processing and reduce administrative costs.',
        image: ClaimsManagement,
        subGroups: [
          {
            category: 'Rejected Claims',
            subTitle:
              'Tracks the distribution and trends of rejected claims to identify potential areas for operational improvement.',
            image: RejectedClaims,
            path: '/rejected-claims',
          },
          {
            category: 'Pending Claims',
            subTitle:
              'Displays the timeline of claims submission and payment, highlighting delays in claims processing.',
            image: PendingClaims,
            path: '/pending-claims',
          },
        ],
      },
      {
        category: 'Medical Claim Utilization',
        subTitle:
          'Focuses on the utilization of medical services, aiming to understand patterns in service utilization, identify cost reduction areas, and ensure appropriate use of resources.',
        image: MedicalClaimUtilization,
        subGroups: [
          {
            category: 'Admission Utilization',
            subTitle:
              'Focuses on hospital admission trends, including the average stay duration and inpatient days per 100 claims.',
            image: AdmissionUtilization,
            path: '/patient-admission',
          },
          {
            category: 'Procedure Utilization',
            subTitle:
              'Examines the expenditure and impact of various medical procedures on plan costs.',
            image: ProcedureUtilization,
            path: '/procedure-utilization',
          },
          {
            category: 'Provider Utilization',
            subTitle:
              'Lists the most utilized facilities and physicians by plan members, offering insights into provider selection.',
            image: ProviderUtilization,
            path: '/provider-utilization',
          },
          {
            category: 'MedPharma Drug Utilization',
            subTitle:
              'Showcases expenditure on MedPharma drugs and identifies the drug types with the highest impact on the plan.',
            image: MedPharmaDrugUtilization,
            path: '/med-pharma',
          },
        ],
      },
      {
        category: 'Drug Utilization',
        subTitle:
          'Analyzes spending and trends in drug utilization, aiming to provide a detailed overview of pharmaceutical expenditures and optimize drug spending.',
        image: DrugUtilization,
        subGroups: [
          {
            category: 'Drug Utilization Summary',
            subTitle:
              'Summarizes broad categorization spending and cost trends of drug spend, including a list of top drugs across various categories, providing a comprehensive overview of drug utilization impacts.',
            image: DrugUtilizationSummary,
            path: '/rx-utilization',
          },
          {
            category: 'MedPharma Drug Utilization',
            subTitle:
              'Showcases expenditure on MedPharma drugs and identifies the drug types with the highest impact on the plan.',
            image: MedPharmaDrugUtilization,
            path: '/med-pharma',
          },
          {
            category: 'Specialty Drug Utilization',
            subTitle:
              'Highlights spending on specialty drugs and pinpoints drug types with significant plan implications.',
            image: SpecialityDrugUtilization,
            path: '/speciality-drugs',
          },
          {
            category: 'Non-Speciality Drug Utilization',
            subTitle:
              'Examines spending on non-speciality drugs beyond MedPharma and specialty categories, identifying high-impact drug types.',
            image: OtherPrescriptionDrugUtilization,
            path: '/other-prescription',
          },
          {
            category: 'GLP-1 Drug Utilization',
            subTitle:
              'Analyzes usage, spending, and member demographics for GLP drugs, identifying whether they are used by members with or without a diabetes diagnosis.',
            image: MultipleDrugs,
            path: '/glp-drugs',
          },
          {
            category: 'Savings Utilization',
            subTitle:
              'Detailed analysis of prescription fills and savings across various programs',
            image: CostPercentile,
            path: '/savings-utilization',
          },
        ],
      },
      {
        category: 'Risk Profile',
        subTitle:
          'Focuses on categorizing members into risk tiers based on various health and utilization metrics. The goal is to identify and manage high-risk groups effectively, providing insights into their healthcare needs and cost implications.',
        image: RiskProfile,
        subGroups: [
          {
            category: 'Chronic Condition Comorbidity',
            subTitle:
              'Categorizes members into five risk tiers based on the number of chronic conditions they have, from 6+ conditions in the highest risk tier to no chronic conditions in the lowest risk tier.',
            image: ChronicConditions,
            path: '/risk-profiling-by-chronic',
          },
          {
            category: 'Trigger Condition Comorbidity',
            subTitle:
              'Categorizes members into five risk tiers based on trigger conditions identified by the SIIA, with the highest risk tier for those with multiple trigger conditions and the lowest risk tier for those with none.',
            image: TriggerConditions,
            path: '/risk-profiling-by-trigger',
          },
          {
            category: 'Cost Percentile',
            subTitle:
              'Tiers members based on their healthcare costs, with the highest tier representing the top 1 percentile of spenders and the lowest tier representing the bottom 60 percentile.',
            image: CostPercentile,
            path: '/risk-profiling-by-cost',
          },
          {
            category: 'High Cost Services Utilization',
            subTitle:
              'Categorizes members based on their utilization of high-cost services such as emergency care, urgent care, and surgeries, with the highest tier for those using more than 5 services and the lowest tier for those using none.',
            image: HighCostUtilization,
            path: '/risk-profiling-by-utilization',
          },
          // {
          //   category: 'Multiple Drug Consumption',
          //   subTitle:
          //     'Tiers members based on the number of different medications they are taking simultaneously, identifying those with the highest medication usage for targeted intervention.',
          //   image: MultipleDrugs,
          //   path: '/risk-profiling-by-drugs',
          // },
        ],
      },
      {
        category: 'Deep Dive',
        subTitle: "Explore the drivers behind the cost and it's trend.",
        path: '/deep-dive',
        image: DeepDive,
      },
      {
        category: 'Trend Analysis',
        subTitle: "Explore the drivers behind the cost and it's trend.",
        path: '/trend-analysis',
        image: TrendAnalysis,
      },
    ],
    PROFILE_PAGE: {
      TOP_CARDS: {
        MEMBER_OF_INTEREST: 'Members of Interest',
        ENGAGEMENTS: 'No. of Engagements',
        CASES_OPENED: 'No. of cases opened',
        CASES_CLOSED: 'No. of cases closed',
      },
    },
  },
  QUARTERLY_REPORT: {
    engagements: 'No. Of Engagements',
    phoneCalls: 'Phone Calls',
    textMessage: 'Text Message',
    email: 'Emails',
    inPerson: 'In-Person',
    videoCalls: 'Video Calls',
    careNavigator: 'Care Navigators',
    nurse: 'Nurse',
    pharmacist: 'Pharmacist',
    customerService: 'Customer Service',
    caseOpened: 'Cases Opened',
    caseClosed: 'Cases Closed',
    overAllSavings: 'Overall Savings',
    totalMembers: 'Total Members of Interest',
    poor: 'Poor',
    fair: 'Fair',
    good: 'Good',
    veryGood: 'Very Good',
    excellent: 'Excellent',
    overAllRating: 'Overall Rating by',
    pieChart: 'Inbound vs Outbound',
  },
};
export default CareNavigatorConstants;
